module.exports = __webpack_public_path__ + "img/footer@2x.ebe4baa1.png";